import { quizChallengeProcessServiceModule } from './quiz-challenge-process-service';
import { firebaseServiceModule } from '../../../../../../shared/app/services/firebase/firebase';
import { quizChallengeQuestionsComponentModule } from '../../../../../../shared/app/components/quiz-challenge-questions/quiz-challenge-questions';
import { interactUserListComponentModule } from '../../../../../../shared/app/components/interact-user-list/interact-user-list';
import { dialogComponentModule } from '../../../../../../shared/app/components/dialog/dialog';
import quizChallengeTemplate from './quiz-challenge.tpl.html';
import introDialogTemplate from './quiz-challenge.intro.tpl.html';
import './quiz-challenge.less';
import { challengeIntroDialogComponentModule } from '../../../../components/challenge-intro-dialog/challenge-intro-dialog';
import { uiRouterStateModule } from '../../../../../../shared/app/vendor/ui-router-module';
import { bufferedSaveHelperModule } from '../../../../../../shared/app/helpers/buffered-save-helper/buffered-save-helper';

export const quizChallengeRouteModule = angular
  .module('Q.routes.assessments.challenges.quiz-challenge', [
    uiRouterStateModule,
    firebaseServiceModule,
    quizChallengeProcessServiceModule,
    quizChallengeQuestionsComponentModule,
    interactUserListComponentModule,
    dialogComponentModule,
    challengeIntroDialogComponentModule,
    bufferedSaveHelperModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('assessments.challenges.quizChallenge', {
      data: {
        bodyClass: 'assessments challenges quiz-challenge',
        label: 'Assessment Challenge IDE',
      },
      resolve: {
        config: /* @ngInject */ function (configService) {
          return configService.load().catch(() => null);
        },
        challengeProcess: /* @ngInject */ function (
          challenge,
          config,
          process,
          quizChallengeProcessService,
        ) {
          return challenge
            ? quizChallengeProcessService.create(challenge, process)
            : null;
        },
      },
      onExit: /* @ngInject */ function (challengeProcess) {
        return challengeProcess && challengeProcess.onExit();
      },
      views: {
        '@assessments': {
          template: quizChallengeTemplate,
          controller: 'QuizChallengeCtrl as $ctrl',
        },
      },
    });
  })

  .controller(
    'QuizChallengeCtrl',
    function QuizChallengeCtrl(
      $scope,
      process,
      challenge,
      challengeProcess,
      dialogService,
      $log,
      $timeout,
      bufferedSaveHelper,
      $state,
    ) {
      const ctrl = this;

      let challengeItem = process.assessmentResult.getChallengeItem(challenge);

      if (!challengeItem) {
        $log.error(
          "Invariant violation: challengeItem was expected to be defined but wasn't",
        );
        return;
      }

      ctrl.challenge = angular.extend(challenge, {
        position: challengeItem.position,
      });
      ctrl.process = challengeProcess;
      ctrl.nextLabel = process.nextLabel;
      ctrl.next = process.next;
      ctrl.previous = process.previous;

      ctrl.highlightErrors =
        !process.restricted &&
        challengeProcess.solution &&
        challengeProcess.solution.attempted();

      if (!challengeProcess.solution) {
        ctrl.showIntro = true;
        ctrl.introDialogTemplate = introDialogTemplate;
        ctrl.beginChallenge = () => {
          if (ctrl.beginning) return;
          ctrl.beginning = true;
          challengeProcess
            .beginChallenge()
            .then(() => {
              process.addSolution(challengeProcess.originalSolution);
              ctrl.showIntro = false;
            })
            .finally(() => {
              $timeout(() => {
                // delayed to let dialog close
                ctrl.beginning = false;
              }, 100);
            });
        };
      }

      const saveSolution = bufferedSaveHelper(challengeProcess.autosave);
      ctrl.saveSolution = saveSolution;

      challengeProcess.resaveAfterFail = () => saveSolution('resaveAfterFail');

      const requireCompleteMultipleChoice = () => {
        return (
          challengeProcess.solution && // we have a solution
          challengeProcess.solution.hasEmptyMultipleChoice() && // we have any empty multiple choice
          !process.isSample() && // we are not in practice or demo mode
          process.assessmentResult.isStarted() && // the assessment result is in the started state
          !process.restricted && // we're not in a restricted editing mode
          !process.liveInterviewActive
        ); // we're not in a live interview
      };

      $scope.$watch(
        () => process.restricted,
        (newVal, oldVal) => {
          if (oldVal !== newVal) {
            $state.reload();
          }
        },
      );

      $scope.$on('$stateChangeStart', (event, toState, toParams) => {
        if (
          toState.name !== 'assessments.welcome' &&
          (saveSolution.isSaving() || requireCompleteMultipleChoice())
        ) {
          event.preventDefault();

          const showNotice = () => {
            dialogService.alert(
              `\
	<p>You need to at least answer all multiple choice questions before continuing.</p>
	`,
              'Be Sure to Answer Completely',
            );
          };

          if (saveSolution.isSaving()) {
            const overlay = dialogService.busyOverlay(
              '',
              'Please wait while we save your answers',
            );
            saveSolution.afterSave.then(() => {
              overlay.close();
              if (requireCompleteMultipleChoice()) {
                showNotice();
              } else {
                $state.go(toState, toParams);
              }
            });
          } else {
            $timeout(showNotice());
          }
        }
      });

      challengeProcess.onEnter($scope);
    },
  );
